// RM-400 — budget flexibility on a group/private dining inquiry: the stored values
// stay the app's two strings; what members read is the approved copy. 10/16 (the
// product agent and Kapil): the question is "Would you go higher than $200pp if
// needed by the restaurant?" — Yes always means they can go higher, No always means
// the amount is the max. Mirrors lib/inquiryStatus.js on the server (one rule, two runtimes).
export const BUDGET_MAX = 'Yes, this is my max'
export const BUDGET_HIGHER = 'No, can go higher if needed'
export const BUDGET_HIGHER_LABEL = 'Yes - I can go higher if needed'

function amountLabel(amount) {
  const n = Number(amount)

  return Number.isFinite(n) && n > 0 ? `$${n.toLocaleString('en-US')}pp` : 'this'
}

export function budgetMaxLabel(amount) {
  return `No - ${amountLabel(amount)} is my max`
}

export function budgetQuestion(amount) {
  return `Would you go higher than ${amountLabel(amount)} if needed by the restaurant?`
}

export function budgetFlexOptions(amount) {
  return [
    { value: BUDGET_HIGHER, label: BUDGET_HIGHER_LABEL },
    { value: BUDGET_MAX, label: budgetMaxLabel(amount) },
  ]
}

export const BUDGET_FLEX_OPTIONS = budgetFlexOptions(null)

export function budgetFlexibilityLabel(value, amount = null) {
  if (!value) return ''

  return /^no/i.test(String(value)) ? BUDGET_HIGHER_LABEL : budgetMaxLabel(amount)
}

// The review's F&B Budget line carries the answer (Kapil, 10/21): "$3,000 ($150pp) - this is my max"
// or "$3,000 ($150pp) - willing to go higher too if needed"; nothing when no answer yet.
export function budgetSummarySuffix(value) {
  if (!value) return ''

  return /^no/i.test(String(value)) ? 'willing to go higher too if needed' : 'this is my max'
}
